<template>
  <v-app>
    <v-container>
      <v-card>
        <v-tabs color="primary" grow>
          <v-tab>{{ $t("vesselList.ContactNumbers") }}</v-tab>
          <v-tab>{{ $t("vesselList.DistributionInternal") }}</v-tab>
          <v-tab>{{ $t("vesselList.DistributionExternal") }}</v-tab>
          <v-tab>{{ $t("vesselList.PersonelOnSite") }}</v-tab>

          <!-- Contact Numbers -->
          <v-tab-item>
            <contact-numbers></contact-numbers>
          </v-tab-item>
          <!-- /Contact Numbers -->

          <!-- Internal Distribution List -->
          <v-tab-item>
            <distribution-list-int></distribution-list-int>
          </v-tab-item>
          <!-- /Internal Distribution List -->

          <!-- External Distribution List -->
          <v-tab-item>
            <distribution-list-ext></distribution-list-ext>
          </v-tab-item>
          <!-- /External Distribution List -->

          <!-- On Site Personnel List -->
          <v-tab-item>
            <onsite-personnel></onsite-personnel>
          </v-tab-item>
          <!-- /On Site Personnel List -->
        </v-tabs>
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
import ContactNumbers from './ContactNumbers'
import OnSitePersonnel from './OnSitePersonnel'
import DistributionListInt from './DistributionListInt'
import DistributionListExt from './DistributionListExt'

export default {
  components: {
    'contact-numbers' : ContactNumbers, 
    'onsite-personnel' : OnSitePersonnel,  
    'distribution-list-int' : DistributionListInt, 
    'distribution-list-ext' : DistributionListExt
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.container {
  max-width: 95%;
}
</style>
